import type { CampaignStatus } from '../types/campaigns.types';

export type CampaignRequestAction = 'claim' | 'unclaim' | 'complete' | 'close';

export const CAMPAIGN_REQUEST_ACTION_LABELS: Record<CampaignRequestAction, string> = {
  claim: 'Claim',
  unclaim: 'Unclaim',
  complete: 'Complete',
  close: 'Close',
};

export function getAvailableCampaignActions(
  status: CampaignStatus,
  assignedToEmail: string | null,
): CampaignRequestAction[] {
  switch (status) {
    case 'new':
      return ['claim', 'close'];
    case 'in_progress':
      return assignedToEmail
        ? ['complete', 'unclaim', 'close']
        : ['complete', 'close'];
    case 'complete':
      return ['close'];
    case 'closed':
      return [];
    default:
      return [];
  }
}
